import React, { useEffect, useState } from 'react'
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  CircularProgress,
} from '@mui/material'
import { green, red } from '@mui/material/colors'
import api from '../../../config/api'

const UserBalance = () => {
  const [balance, setBalance] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  // Функция для получения данных о балансе
  const fetchBalance = async () => {
    try {
      const response = await api.get('/API_FRONT/user/balance/')
      setBalance(response?.data?.balance || 0)
    } catch (error) {
      console.error('Ошибка при получении баланса:', error)
      setError('Не удалось загрузить данные баланса')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchBalance()
  }, [])

  // Выбор цвета и текста в зависимости от состояния баланса
  const isNegativeBalance = balance <= 0
  const cardColor = isNegativeBalance ? red[100] : green[100]
  const avatarColor = isNegativeBalance ? red[500] : green[500]
  const balanceMessage = isNegativeBalance ? 'На аккаунте долг' : 'Баланс'

  return (
    <Card sx={{ backgroundColor: cardColor, mb: 2 }}>
      <CardContent>
        <Grid container alignItems="center">
          <Grid item xs={3}>
            <Avatar sx={{ bgcolor: avatarColor, width: 56, height: 56 }}>
              💵
            </Avatar>
          </Grid>
          <Grid item xs={9}>
            {loading ? (
              <CircularProgress />
            ) : error ? (
              <Typography variant="body1" color="error">
                {error}
              </Typography>
            ) : (
              <>
                <Typography variant="h6">{balanceMessage}</Typography>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                  Баланс: {balance} ₽
                </Typography>
              </>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default UserBalance
